// extracted by mini-css-extract-plugin
export var title = "PageNewsLanding-module--title--ReEmb";
export var wrapper = "PageNewsLanding-module--wrapper--iQULh";